module.exports = __webpack_public_path__ + "static/media/hopp7024.ab1e57dd.png";